import React from 'react'

const Downloads = () => {
    return (
        <div>
            <h1>This is the downloads page</h1>
        </div>
    )
}

export default Downloads